// src/internals/getArrayQueryKey.ts
function getArrayQueryKey(path, input, type) {
  const hasInput = typeof input !== "undefined";
  const hasType = type && type !== "any";
  if (!hasInput && !hasType)
    return path.length ? [path] : [];
  const inputAndType = {};
  if (hasInput)
    inputAndType.input = input;
  if (hasType)
    inputAndType.type = type;
  return [path, inputAndType];
}

export {
  getArrayQueryKey
};
